import { render, staticRenderFns } from "./ModificarContrato.vue?vue&type=template&id=50737964&scoped=true"
import script from "./ModificarContrato.vue?vue&type=script&lang=js"
export * from "./ModificarContrato.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50737964",
  null
  
)

export default component.exports